import { useEffect } from 'react';
import { useConfigurationContext } from '@/root/ConfigurationContext';

/** Syncs `document.title` to `{page} | {app}` when `page` is set. */
export function useBrowserTitle(page?: string | null) {
    const { title: appTitle } = useConfigurationContext();
    const app = appTitle || 'MRT Dashboard';

    useEffect(() => {
        if (!page) return;
        document.title = `${page} | ${app}`;
    }, [page, app]);
}
